import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import "./quill.scss"

const QEditor = ({value, setValue}) => {



  return <ReactQuill theme="snow" defaultValue={value} onChange={(content) => setValue(content)} />;
}

export default QEditor;